// extracted by mini-css-extract-plugin
module.exports = {"intro":"styles_intro__fBvzk","pulse":"styles_pulse__Q5Koa","jump":"styles_jump__RMzCh"};